<app-header></app-header>
<ion-content
  id="menu-profit-pro"
  class="gray-content-bg"
  [class.desktop]="platformService?.platformType === platformService?.platformEnum?.desktop "
  [class.mobile]="platformService?.platformType !== platformService?.platformEnum?.mobile "
  [class.tablet]="platformService?.platformType !== platformService?.platformEnum?.tablet "
  *ngIf="(viewModel$ | async) as viewModel"
  scroll-y="false"
  [class.mobile-content]="platformService?.platformType === platformService?.platformEnum?.mobile"
>
  <cdk-virtual-scroll-viewport
    id="recipe-page"
    data-cy="recipe-page-scroll"
    class="cdk-scroll recipe-page-scroll"
    orientation="vertical"
    appInvVs
    [itemHeights]="viewModel?.itemHeights"
    [indexOffset]="1"
    minBufferPx="2000"
    maxBufferPx="4000"
  >
    <app-sub-menu
      [currentPage]="currentPage"
      [translateService]="translateService"
      [items]="viewModel.subMenuItems"
      [platform]="platformService.platformType"
      (clickEvent)="gotoRequest($event)"
      [class.mobile]="platformService?.platformType === platformService?.platformEnum?.mobile"
      *ngIf="platformService?.platformType !== platformService?.platformEnum?.mobile || (platformService?.platformType === platformService?.platformEnum?.mobile && viewModel.loaded)"
    >
    </app-sub-menu>
    <ion-grid
      data-cy="menu-profit-pro-header"
      class="menu-profit-pro-mobile"
      [fixed]="true"
      *ngIf="viewModel.doRecipesExist && viewModel.loaded && platformService.platformEnum.mobile === platformService.platformType"
    >
      <ng-container [ngTemplateOutlet]="searchFilterMobile"> </ng-container>
    </ion-grid>

    <ion-grid
      data-cy="menu-profit-pro-content"
      class="menu-profit-pro-content"
      [fixed]="true"
      [class.missing]="!viewModel.doRecipesExist || (viewModel.doRecipesExist && viewModel.recipes.length === 0)"
    >
      <ng-container
        *ngIf="!viewModel.loaded"
        [ngTemplateOutlet]="landingSkeleton"
      ></ng-container>
      <ng-container
        *ngIf="viewModel.doRecipesExist && viewModel.loaded && platformService.platformEnum.mobile !== platformService.platformType"
        [ngTemplateOutlet]="searchFilterBar"
      >
      </ng-container>

      <app-sortable-section-desktop-tablet
        *ngIf="viewModel.loaded && platformService.platformEnum.mobile !== platformService.platformType && viewModel.doRecipesExist"
        [sectionTitle]="''"
        [showTitle]="false"
        [sectionHeaders]="viewModel.sectionHeaders"
        [selectedHeader]="viewModel.selectedHeader"
        [hasSectionData]="viewModel.recipes.length > 0 && !viewModel.searchKey"
        [noDataText]="''"
        [alternateDesign]="true"
        [showSelectAll]="true"
        [selectAllSelected]="viewModel.isEverythingShownSelected"
        [nothingToSelect]="viewModel.recipes.length === 0"
        (updateSortEventEmitter)="updateSort($event)"
        (selectAllEmitter)="handleSelectAll(viewModel.recipes, viewModel.isEverythingShownSelected)"
      >
      </app-sortable-section-desktop-tablet>
      <div
        *ngIf="!viewModel.doRecipesExist && viewModel.loaded"
        class="no-recipes"
      >
        <img
          src="assets/images/box-dimension-black.svg"
          class="box-dimension-image"
          alt="box-image"
        />
        <p>{{ 'i18n.menuProfitPro.recipes.noRecipe' | translate}}</p>
        <ng-container [ngTemplateOutlet]="addRecipeButton"></ng-container>
      </div>
      <div
        *ngIf="viewModel.doRecipesExist && viewModel.recipes.length === 0 && viewModel.loaded"
        class="no-recipes"
      >
        <ng-container [ngTemplateOutlet]="noSearchResults"></ng-container>
      </div>

      <app-recipe-card
        *cdkVirtualFor="
    let recipe of viewModel.recipes;
    let i = index;
    trackBy: trackItem
  "
        [cardData]="recipe"
        [platform]="platformService.platformType"
        (selectCard)="handleOnRecipeClick($event)"
        (ellipsisClick)="handleOnEllipsisClick($event, viewModel.recipes)"
        (goToRecipeEvent)="goToDetails($event)"
      >
      </app-recipe-card>
      <div class="big-space" *ngIf="viewModel.recipes.length <= 5"></div>
    </ion-grid>
    <app-footer></app-footer>
  </cdk-virtual-scroll-viewport>
  <ng-container
    *ngIf="viewModel?.selectedRecipes?.length > 0"
    [ngTemplateOutlet]="selectedRecipesActionBar"
    [ngTemplateOutletContext]="{ viewModel: viewModel }"
  ></ng-container>

  <ion-modal
    [isOpen]="recipeService.deleteModalIsOpen"
    (ionModalDidDismiss)="handleDelteConfirmationDismiss()"
    [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
    [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
    [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' :'archive-delete-confirmation-modal-desktop'"
    id="delete-mpp-confirmation-modal"
  >
    <ng-template>
      <app-delete-mpp-confirmation-modal
        class="ion-page"
        [platform]="platformService.platformType"
        [data]="recipeService.deleteArchiveData"
        (submitEvent)="handleDeleteConfirmationSubmission($event)"
        (dismissEvent)="handleDelteConfirmationDismiss()"
      >
      </app-delete-mpp-confirmation-modal>
    </ng-template>
  </ion-modal>

  <app-sort-filter-mpp-modal-container
    (submitEvent)="handleModalSubmission($event)"
    (clearAll)="clearAllFiltersSort()"
    [exisitingGroupFilter]="viewModel.filteredGroups"
    [existingSort]="viewModel.sortSelected"
    [groups]="viewModel.allGroups"
    [isActive]="viewModel.filterArchive"
  >
  </app-sort-filter-mpp-modal-container>
  <ion-modal
    [isOpen]="mppService.createMppModalIsOpen"
    (ionModalDidDismiss)="mppService.handleCreateMppDismiss()"
    [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
    [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
    [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' :'create-mpp-modal-desktop'"
    id="create-mpp-modal"
  >
    <ng-template>
      <app-create-mpp-modal
        class="ion-page"
        [platform]="platformService.platformType"
        [data]="mppService.createMppDataModalData"
        [title]="createRecipeTitle"
        [typeSelection]="defaultCreateMppSelction"
        (submitEvent)="mppService.handleCreateMppSubmission($event)"
        (dismissEvent)="mppService.handleCreateMppDismiss()"
      >
      </app-create-mpp-modal>
    </ng-template>
  </ion-modal>
  <app-copy-recipe-create-modal
    [platform]="platformService.platformType"
    [translateService]="translateService"
    [data]="recipeService.copyMppData"
    [userKind]="viewModel.userKind"
    (submitEvent)="handlCopyRecipeCreation($event)"
  >
  </app-copy-recipe-create-modal>
</ion-content>

<ng-template #landingSkeleton>
  <app-recipe-landing-skeleton
    [platform]="platformService?.platformType"
  ></app-recipe-landing-skeleton>
</ng-template>

<ng-template #noSearchResults>
  <div
    data-cy="recipes-no-search-results-container"
    class="recipes-no-search-results"
  >
    <span data-cy="all-inventories-no-search-results-text">
      {{ 'i18n.search.noSearchResults.noResultFound' | translate }}
    </span>
    <span data-cy="all-inventories-no-search-results-subtext">
      {{ 'i18n.search.noSearchResults.pleaseTryAgain' | translate }}
    </span>
  </div>
</ng-template>

<ng-template #searchFilterBar>
  <ion-row class="search-filter">
    <ion-col
      data-cy="search-text-col"
      [offset]="platformService.platformEnum.tablet === platformService.platformType ? 0.25 : 0"
      [size]="3"
    >
      <ion-searchbar
        data-cy="recipes-searchbar"
        class="search"
        mode="md"
        placeholder="{{ 'i18n.menuProfitPro.recipes.searchPlaceholder' | translate }}"
        (ionInput)="search($event.target.value)"
      ></ion-searchbar>
    </ion-col>
    <ion-col
      data-cy="filter-col"
      [size]="platformService.platformEnum.tablet === platformService.platformType ? 1.5 : 1"
      class="search-buttons"
    >
      <ion-button (click)="openSortModal()" class="usf-outline-green-button">
        {{ 'i18n.common.filter' | translate }}
        <ion-icon name="filter-outline" class="filter-icon"></ion-icon>
      </ion-button>
    </ion-col>
    <ion-col
      data-cy="filter-col"
      [offset]="platformService.platformEnum.tablet === platformService.platformType ? 0.25 : 0"
      [size]="platformService.platformEnum.tablet === platformService.platformType ? 1.75 : 1"
      class="search-buttons"
    >
      <a
        href="javascript:void(0)"
        (click)="clearAllFiltersSort()"
        class="clear-all-link search-buttons"
      >
        {{ 'i18n.common.clearAll' | translate }}
      </a>
    </ion-col>
    <ion-col
      data-cy="add-col"
      class="align-right"
      [offset]="platformService.platformEnum.tablet === platformService.platformType ? 1 : 0"
      [size]="platformService.platformEnum.tablet === platformService.platformType ? 3.25 : 7"
    >
      <ng-container [ngTemplateOutlet]="addRecipeButton"></ng-container>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #searchFilterMobile>
  <ion-row class="search-filter-mobile">
    <ion-col data-cy="search-col" size="8.25">
      <ion-searchbar
        data-cy="recipes-searchbar"
        class="search"
        mode="md"
        placeholder="{{ 'i18n.menuProfitPro.recipes.searchPlaceholder' | translate }}"
        (ionInput)="search($event.target.value)"
      ></ion-searchbar>
    </ion-col>
    <ion-col data-cy="filter-col" size="1.25">
      <div class="icon">
        <ion-icon (click)="openSortModal()" name="filter-outline"></ion-icon>
      </div>
    </ion-col>
    <ion-col data-cy="clear-all-col" size="1.25">
      <div class="icon">
        <ion-icon
          (click)="clearAllFiltersSort()"
          name="close-outline"
        ></ion-icon>
      </div>
    </ion-col>
    <ion-col data-cy="add-recipe-col" size="1.25">
      <div class="icon">
        <ion-icon
          (click)="mppService.openCreatePopover()"
          name="add-circle-outline"
        ></ion-icon>
      </div>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Add Recipe Button -->
<ng-template #addRecipeButton>
  <ion-button
    [class]="'usf-fill-green-button'"
    data-cy="recipe-page-add-recipe-button"
    (click)="mppService.openCreatePopover()"
  >
    {{ 'i18n.menuProfitPro.actions.addRecipe' | translate }}
    <ion-icon
      class="thick"
      data-cy="recipe-page-add-recipe-button-icon"
      name="add-outline"
    ></ion-icon>
  </ion-button>
</ng-template>

<ng-template #selectedRecipesActionBar let-viewModel="viewModel">
  <ion-card
    data-cy="recipe-page-selected-products-bar"
    class="recipe-selected-products-bar"
  >
    <ng-container>
      <div
        data-cy="recipe-page-product-selection-section"
        class="recipe-product-options"
      >
        <ion-text
          data-cy="recipe-page-num-selected-products-text"
          class="bold-font-weight"
        >
          {{ (viewModel.selectedRecipes?.length) }}&nbsp;{{
          ((viewModel.selectedRecipes?.length) > 1 ?
          'i18n.menuProfitPro.actionBar.recipes' :
          'i18n.menuProfitPro.actionBar.recipe') | translate }} &nbsp;{{
          'i18n.lists.selected' | translate }}
        </ion-text>
        <ng-container *ngIf="!viewModel.isEverythingShownSelected">
          <div
            class="separator"
            data-cy="recipe-page-separator-image"
            src="assets/images/divider-white.svg"
          ></div>
          <ion-label
            data-cy="recipe-page-select-all-text"
            (click)="handleSelectAll(viewModel.recipes, false)"
          >
            {{ 'i18n.lists.selectAll' | translate }}
          </ion-label>
        </ng-container>
        <div
          class="separator"
          data-cy="recipe-page-separator-image"
          src="assets/images/divider-white.svg"
        ></div>
        <ion-label
          data-cy="recipe-page-deselect-all-text"
          (click)="handleSelectAll(viewModel.recipes, true)"
        >
          {{ 'i18n.lists.deselectAll' | translate }}
        </ion-label>
      </div>
      <div
        data-cy="recipe-page-product-actions-section"
        class="recipe-product-options"
      >
        <ion-label
          data-cy="recipe-page-change-units-button"
          class="medium-font-weight"
          (click)="handleBulkArchive(viewModel.selectedRecipes, viewModel.filterArchive)"
        >
          {{ (viewModel?.filterArchive === true ?
          'i18n.menuProfitPro.actions.archive' :
          'i18n.menuProfitPro.actions.unarchive') | translate }}
        </ion-label>
        <div
          class="separator"
          data-cy="recipe-page-separator-image"
          src="assets/images/divider-white.svg"
        ></div>
        <ion-label
          data-cy="recipe-delete-products-button"
          class="medium-font-weight"
          (click)="handleBulkDelete(viewModel.selectedRecipes)"
        >
          {{ 'i18n.common.delete' | translate }}
        </ion-label>
      </div>
    </ng-container>
  </ion-card>
</ng-template>
